<template>
  <loader v-if="loading"></loader>
  <find-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :filters="filters"
    :page-request="pageRequest"
    :sorters="sorters"
    :page="page"

    filters-title="Ricerca tag"
    results-title="Tag"
    no-results-message="Nessun tag trovato"

    @selectPageSize="selectPageSize"
    @find="find"
    @sort="sortBy"
    @selectPage="selectPage">
    <b-card slot="filters">
      <tag-filters v-model="filters" />
    </b-card>
    <b-row slot="results">
      <b-col v-for="r in page.content" sm="6" md="4">
        <router-link-card
          :disabled="!r.permissions.load"
          :to="{ name: 'Tag', params: { id: r.id } }">
          <div>
            <span class="font-weight-bold">{{ r.label }}</span>
            <tag
              v-if="r.workgroup"
              class="ml-2"
              v-bind="tagFor(r.workgroup)"
            />
          </div>
        </router-link-card>
      </b-col>
    </b-row>
    <div
      v-if="page.permissions && page.permissions.create"
      slot="bottom-buttons"
      class="text-right mb-2">
      <b-button variant="success" :to="{ name: 'Tag', params: { id: 'new' } }">
        Nuovo
      </b-button>
    </div>
  </find-page-layout>
</template>
<script>
import TagService from 'app/services/TagService';
import FindPageMixin from 'vue-core/mixins/FindPageMixin';
import { tagForWorkgroup } from 'app/utils';

export default {
  mixins: [ FindPageMixin ],

  created() {
    this.service = TagService;
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Tag'
        }
      ];
    },

    sorters() {
      return [
        {
          label: 'Etichetta',
          path: 'label'
        },
      ];
    }
  },

  methods: {
    tagFor(workgroup) {
      return tagForWorkgroup(workgroup);
    }
  }
}
</script>
